import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { DataTable } from "@/components/shared/DataTable";
import { StatusPill } from "@/components/shared/StatusPill";

export default function Movements() {
  const [movements, setMovements] = useState([]);
  const [items, setItems] = useState([]);
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    api.get("/inventory/movements").then((r) => setMovements(r.data)).catch(() => {});
    api.get("/inventory/items").then((r) => setItems(r.data)).catch(() => {});
    api.get("/inventory/locations").then((r) => setLocations(r.data)).catch(() => {});
  }, []);
  const itemName = (id) => items.find((i) => i.id === id)?.name || "—";
  const locName = (id) => locations.find((l) => l.id === id)?.name || (id ? id.slice(0, 6) : "—");
  const cols = [
    { key: "created_at", header: "When", render: (r) => new Date(r.created_at).toLocaleString() },
    { key: "item", header: "Item", render: (r) => <span className="font-medium text-slate-900">{itemName(r.item_id)}</span> },
    { key: "type", header: "Type", render: (r) => <StatusPill value={r.type} /> },
    { key: "location", header: "Location", render: (r) => locName(r.location_id) },
    { key: "quantity_change", header: "Change", align: "right", mono: true, render: (r) => <span className={r.quantity_change >= 0 ? "text-emerald-600" : "text-red-600"}>{r.quantity_change > 0 ? "+" : ""}{r.quantity_change}</span> },
    { key: "balance_after", header: "Balance", align: "right", mono: true },
    { key: "actor_name", header: "By", render: (r) => r.actor_name || "—" },
  ];
  return (
    <div>
      <PageHeader title="Stock Movements" subtitle="Every quantity change is recorded — no silent edits" />
      <DataTable testid="inventory-all-movements-table" columns={cols} rows={movements} empty="No movements yet" />
    </div>
  );
}
